import request from '../../config/axiosConfig';
import {
  GET_LIST_PREMIUM_ORDERS, GET_PREMIUM_ORDER_INFO, CREATE_PREMIUM_ORDER,
  UPDATE_PREMIUM_ORDER, DELETE_PREMIUM_ORDER, CHANGE_ALL_PREMIUM_ORDERS,
  ASSIGN_STAFF_PREMIUM_ORDER, GET_PREMIUM_ORDER_OPTIONS,
  EXPORT_PREMIUM_ORDERS, IMPORT_PREMIUM_ORDERS, CHECK_APPLE_ORDER_ID,
  BULK_ASSIGN_STAFF, GET_USER_BY_ID, SEARCH_USERS,
} from '../../constants/apiEndPoint';

export const getListPremiumOrdersRequest = async (data) => {
  const result = await request({ url: GET_LIST_PREMIUM_ORDERS, method: 'POST', data });
  return result?.data.data;
};

export const getPremiumOrderInfoRequest = async (data) => {
  const result = await request({ url: GET_PREMIUM_ORDER_INFO, method: 'POST', data });
  return result?.data.data;
};

export const createPremiumOrderRequest = async (data) => {
  const result = await request({ url: CREATE_PREMIUM_ORDER, method: 'POST', data });
  return result?.data;
};

export const updatePremiumOrderRequest = async (data) => {
  const result = await request({ url: UPDATE_PREMIUM_ORDER, method: 'POST', data });
  return result?.data;
};

export const deletePremiumOrderRequest = async (data) => {
  const result = await request({ url: DELETE_PREMIUM_ORDER, method: 'POST', data });
  return result?.data;
};

export const changeAllPremiumOrdersRequest = async (data) => {
  const result = await request({ url: CHANGE_ALL_PREMIUM_ORDERS, method: 'POST', data });
  return result?.data;
};

export const assignStaffPremiumOrderRequest = async (data) => {
  const result = await request({ url: ASSIGN_STAFF_PREMIUM_ORDER, method: 'POST', data });
  return result?.data;
};

export const getPremiumOrderOptionsRequest = async (data) => {
  const result = await request({ url: GET_PREMIUM_ORDER_OPTIONS, method: 'POST', data });
  return result?.data.data;
};

export const exportPremiumOrdersRequest = async (data) => {
  const result = await request({ url: EXPORT_PREMIUM_ORDERS, method: 'POST', data });
  return result?.data.data;
};

export const importPremiumOrdersRequest = async (data) => {
  const result = await request({ url: IMPORT_PREMIUM_ORDERS, method: 'POST', data });
  return result?.data;
};

export const checkAppleOrderIdRequest = async (data) => {
  const result = await request({ url: CHECK_APPLE_ORDER_ID, method: 'POST', data });
  return result?.data.data;
};

export const bulkAssignStaffRequest = async (data) => {
  const result = await request({ url: BULK_ASSIGN_STAFF, method: 'POST', data });
  return result?.data;
};

export const getUserByIdRequest = async (data) => {
  const result = await request({ url: GET_USER_BY_ID, method: 'POST', data });
  return result?.data.data;
};

export const searchUsersRequest = async (data) => {
  const result = await request({ url: SEARCH_USERS, method: 'POST', data });
  return result?.data.data;
};
